import { HowItWorks } from "@/components/admin/HowItWorks";
import AdminShell from "@/components/admin/AdminShell";
import { MailboxSetup } from "@/components/outreach/MailboxSetup";
import { MailboxHealthBanner } from "@/components/outreach/MailboxHealth";
import { SendingCard } from "@/components/outreach/SendingCard";
import { TeamMailboxes } from "@/components/outreach/TeamMailboxes";

export default function MailboxSetupPage() {
  return (
    <AdminShell title="Mailbox Sign-in" subtitle="Add your Google and Microsoft sign-in keys so sequence emails send from each user's own Gmail or Outlook inbox, and replies come back to it.">
      <div className="space-y-6">
        <MailboxHealthBanner client={null} />
        <TeamMailboxes client={null} />
        <div className="mb-5"><HowItWorks id="use-mailbox" /></div>
        <MailboxSetup client={null} />
        <SendingCard client={null} />
      </div>
    </AdminShell>
  );
}
